<template>
  <div id="mb-title" :style="[{ '--color': color }]">
    <transition name="icon-fade">
      <div class="icon-box" @mouseenter="iconHover = true" @mouseleave="iconHover = false">
        <img
          draggable="false"
          class="title-icon"
          @click="
            popoutStatus = !popoutStatus;
            startPlay();
          "
          :src="titleIcon"
        />
        <transition name="icon-fade">
          <img
            draggable="false"
            v-if="iconHover"
            class="title-icon"
            @click="
              popoutStatus = !popoutStatus;
              startPlay();
            "
            :src="titleIconOn"
          />
        </transition>
      </div>
    </transition>
    <transition name="popout-fade">
      <div class="popout-title" v-if="popoutStatus">
        <div class="avatar-box">
          <img draggable="false" class="title-avatar" :src="icon" />
          <div class="title-avatar-dot" :src="icon"></div>
        </div>
        <div class="title-box">
          <p v-html="title"></p>
        </div>
        <div class="cancel-icon">
          <svg
            width="100%"
            height="100%"
            v-if="popoutStatus"
            @click="
              popoutStatus = !popoutStatus;
              stopPlay();
            "
            viewBox="0 0 100 100"
          >
            <path
              stroke-width="10px"
              fill="white"
              d="M20 20, 80 80Z M 20 80, 80 20"
              stroke="black"
              class="cancel-icon-path"
            />
          </svg>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { Howler } from 'howler';
import { getGamePath } from '__mainSrcDir/components/TrGame/v4/Utils/pathUtils.js';

export default {
  name: 'mb-title',
  components: {},
  data: function () {
    return {
      iconHover: false,
      popoutStatus: false,
      titleAudio: null,
      audioStatus: null,
    };
  },
  props: {
    title: {
      type: String,
      default: function () {
        return '';
      },
    },
    audio: {
      type: String,
      default: function () {
        return null;
      },
    },
    icon: {
      type: String,
      default: function () {
        return '';
      },
    },
  },
  beforeMount() {
    this.init();
  },
  beforeDestroy() {
    this.stopPlay();
  },
  mounted() {
    setTimeout(() => {
      if (this.titleAudio) {
        this.startPlay();
      } else {
        setTimeout(() => {
          this.popoutStatus = false;
        }, 5000);
      }
      this.popoutStatus = true;
    }, 500);
  },
  methods: {
    startPlay() {
      Howler.stop();
      if (this.titleAudio) {
        if (!this.titleAudio.playing()) {
          // Howler.stop();
          this.titleAudio.play();
        }
      }
    },
    stopPlay() {
      if (this.titleAudio) {
        this.titleAudio.stop();
      }
    },
    init() {
      this.setAudioConfig();
    },
    setAudioConfig() {
      if (this.audio) {
        this.titleAudio = new Howl({
          src: this.giveMeImagePlease(this.audio),
          autoplay: false,
          loop: false,
          volume: 0.5,
          onend: () => {
            this.audioStatus = false;
            setTimeout(() => {
              this.popoutStatus = false;
            }, 2000);
          },
          onpause: () => {
            this.audioStatus = false;
          },
          onstop: () => {
            this.audioStatus = false;
          },
          onplay: () => {
            this.audioStatus = true;
            this.popoutStatus = true;
          },
        });
      }
    },
    giveMeImagePlease(path) {
      try {
        let audioPath = getGamePath(path);
        return require(`__staticDir/${this.$store.getters.multibookType}/${audioPath}`);
      } catch {
        console.log(
          '%cImagePath MbTitle- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
    },
  },
  computed: {
    color() {
      // return this.$store.getters.getGameColor;
      return this.$store.getters.getMainColor;
    },
    titleIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/title-64px.png`);
      } catch {
        console.log(
          '%cTitleIcon MbTitle- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    titleIconOn() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/title-on-64px.png`);
      } catch {
        console.log(
          '%cTitleIconOn MbTitle- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~@/assets/sass/variable'
$break-large: 1400px
.title-icon
  position: absolute
  z-index: 5
  top: 25px
  left: 30px
  // top: calc(64px/3)
  // left: calc(64px/3)
  width: 48px
  // margin: calc(64px / 4)
  transition: .5s
  // transform: scale(.9)
  cursor: pointer
  &:hover
    // transform: scale(1)
.cancel-icon
  width: calc(64px/2)
  z-index: 5
  height: calc(64px /2)
  position: absolute
  top: 10px
  right: 10px
  transition: .5s
  transform: scale(.9)
  opacity: .7
  cursor: pointer
  &:hover
    transform: scale(1)
    opacity: 1
.popout-title
  z-index: 5
  padding-right: calc(64px/2 + 10px)
  width: 67%
  position: absolute
  top: calc(64px/3)
  left: calc(64px/3)
  background: white
  font-family: $gameFontFamily
  text-align: left
  display: flex
  flex-direction: row
  align-items: center
  justify-content: center
  border-radius: calc(64px/6)
  min-height: 82px
  .avatar-box
    width: calc(96px + 64px/4)
    height: 100%
    display: flex
    flex-direction: row
    align-items: center
    justify-content: center
    min-width: 60px
    min-height: 60px
    .title-avatar
      width: 70px
      position: absolute
      top: -19px
      z-index: 1
      transform: scaleX(-1)
      // margin: calc(64px / 4)
      margin-top: 0
    .title-avatar-dot
      background: var(--color)
      z-index: 0
      position: absolute
      top: 20px
      width: 60px
      height: 60px
      border-radius: 50%
      box-shadow: inset 0px -1px 10px rgba(0, 0, 0, 0.5)
  .title-box
    margin-top: calc(64px / 4)
    margin-bottom: calc(64px / 4)
    margin-left: calc(64px / 4)
    width: calc(100% - 3* (64px / 4) - 96px)
    height: 100%
    display: flex
    flex-direction: row
    align-items: center
    justify-content: flext-start
    p
      margin: 0
      padding: 0
      font-size: 24px !important

.popout-fade-leave-active, .popout-fade-enter-active
  transition: all .5s ease-in-out
.popout-fade-leave-to, .popout-fade-enter
  transform: translateX(-110%)
  opacity: 0
.icon-fade-leave-active, .icon-fade-enter-active
  transition: all .5s linear
.icon-fade-leave-to, .icon-fade-enter
  opacity: 0

@keyframes iconShow
  0%
    opacity: 0
    // transform: rotate(-25deg) scale(.9)
  100%
    opacity: 1
</style>
